export default __webpack_public_path__ + "static/media/CarImages.KigerGallery3.b3b020bb.jpg";